import axios from "axios";

const api = axios.create({
  baseURL: "https://apiequals9.herokuapp.com/sistem",
});

export default api;
